module.exports = __webpack_public_path__ + "shell/assets/brand/suse/rancher-logo.svg";